export const pricingData = [
	{
		title: 'Starter',
		price: '$65 - $190 Per Month',
		numAcc: '50-100 accounts',
		features: ['Website Modification', 'Keyword Analysis & SEO', 'On-page optimization', '1 Lead Generation Campaign / Qtr', 'Email Marketing'],
	},
	{
		title: 'Bronze',
		price: '$299 - $400 Per Month',
		numAcc: '50-500 accounts',
		features: [
			'Fully Mobile-Responsive Website',
			'Keyword Analysis & SEO',
			'On-page optimization',
			'3 Lead Generation Campaign / Qtr',
			'Marketing Dashboard',
		],
	},
	{
		title: 'Silver',
		price: '$450 - $650 Per Month',
		numAcc: '50-1000 accounts',
		features: [
			'Fully Mobile-Responsive Website',
			'Keyword Analysis & SEO',
			'On-page optimization',
			'3 Lead Generation Campaigns / Mon.',
			'Marketing Dashboard',
		],
	},

	{
		title: 'Gold',
		price: '$700 - $999 Per Month',
		numAcc: '1000+ Accounts',
		features: ['Fully Mobile-Responsive Website', 'Keyword Analysis & SEO', 'On-page optimization', 'Lead Generation Campaigns / Mon.', 'Marketing Dashboard'
		
	],
	},
];
